import { AppImageDisplayInfo } from "../AppIcon/common";
import { AppColorViewModel } from "../Apps/common";
import {
	SearchIntegrationKind,
	GlobalSearchScopeIdentifier,
	GlobalSearchScopeKind
} from "../TitleBar/GlobalSearch/globalSearch";
import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export enum SearchSortKind {
	AlphabeticalAscending = 0,
	AlphabeticalDescending = 1,
	Custom = 2
}

export enum SearchNodeKind {
	Scope = 1,
	Group = 2
}

export type SearchNodeScopeDataSaveModel = {
	scope: GlobalSearchScopeIdentifier;
};

export type ScopeSearchNodeSaveModel = {
	kind: SearchNodeKind.Scope;
	scopeData: SearchNodeScopeDataSaveModel;
};

export type SearchNodeGroupDataSaveModel = {
	id: string | null;
	name: string;
	scopes: readonly ScopeSearchNodeSaveModel[];
};

export type GroupSearchNodeSaveModel = {
	kind: SearchNodeKind.Group;
	groupData: SearchNodeGroupDataSaveModel;
};

export type PredefinedScopeSearchNodeViewModel = {
	kind: SearchNodeKind.Scope;
	name: string;
	scopeKind: GlobalSearchScopeKind.Predefined;
	predefinedKind: SearchIntegrationKind;
};

export type IntegrationFlowScopeSearchNodeViewModel = {
	kind: SearchNodeKind.Scope;
	scopeKind: GlobalSearchScopeKind.IntegrationFlow;
	integrationId: number;
	name: string;
	color: AppColorViewModel;
	imageDisplayInfo: AppImageDisplayInfo;
};

export type ScopeSearchNodeViewModel =
	| PredefinedScopeSearchNodeViewModel
	| IntegrationFlowScopeSearchNodeViewModel;

export type GroupSearchNodeViewModel = {
	kind: SearchNodeKind.Group;
	id: string;
	name: string;
	scopes: readonly ScopeSearchNodeViewModel[];
};

export type SearchNodeViewModel =
	| GroupSearchNodeViewModel
	| ScopeSearchNodeViewModel;

export type SearchNodeSaveModel =
	| GroupSearchNodeSaveModel
	| ScopeSearchNodeSaveModel;

export type SearchSettingsViewModel = {
	sortKind: SearchSortKind;
	nodes: readonly SearchNodeViewModel[];
};

export type SearchSettingsSaveModel = {
	sortKind: SearchSortKind;
	nodes: readonly SearchNodeSaveModel[];
};

export function getSearchSettings(
	signal: AbortSignal
): Promise<SearchSettingsViewModel> {
	return httpClient.get<SearchSettingsViewModel>(
		"/UiApi/SearchSettings",
		undefined,
		{ signal }
	);
}

export function saveSearchSettings(
	model: SearchSettingsSaveModel,
	signal: AbortSignal
): Promise<SearchSettingsViewModel> {
	return httpClient.put<SearchSettingsViewModel>(
		"/UiApi/SearchSettings",
		model,
		{ signal }
	);
}